import {
  Avatar,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import appcolors from "../../../constants/Colors";
import { t } from "i18next";

const tableStyle = {
  "&.MuiTableContainer-root": {
    border: "1px solid grey",
    borderRadius: 1,
    overFlow: "hidden",
  },
  "&.MuiTableContainer-root .MuiTableHead-root": {
    backgroundColor: appcolors.primary,
  },
  "&.MuiTableContainer-root .MuiTableHead-root .MuiTableRow-root .MuiTableCell-root":
    {
      padding: "6px 16px",
      color: appcolors.white,
      fontSize: "1rem",
    },
};

const UserDetail = ({ detail, location }) => {
  return (
    <TableContainer sx={tableStyle}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell>{t("image")}</TableCell>
            <TableCell>{t("name")}</TableCell>
            <TableCell>{t("email")}</TableCell>
            <TableCell>{t("contact")}</TableCell>
            <TableCell>{t("address")}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              <Avatar
                src={detail?.profileImg}
                sx={{
                  height: 60,
                  width: 60,
                  borderRadius: 2,
                  border: "1px solid grey",
                }}
              />
            </TableCell>
            <TableCell>
              <Typography textTransform={"capitalize"} fontWeight={600}>
                {`${detail?.firstname} ${detail?.lastname}`}
              </Typography>
            </TableCell>
            <TableCell>{detail?.email}</TableCell>
            <TableCell>{detail?.contact}</TableCell>
            <TableCell>
              <Typography>
                {location?.country}/{location?.state}/{location?.city}/
                {location?.zipCode}
              </Typography>
              <Typography>{location?.address}</Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default UserDetail;
